import {Injectable, isDevMode} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {AccountService} from '@supoui/core/auth/account.service';
import {StateStorageService} from './state-storage.service';
import {AuthenticationService} from "@supoui/core/auth/authentication.service";

@Injectable({ providedIn: 'root' })
export class UserRouteAccessService  {
  constructor(
    private router: Router,
    private accountService: AccountService,
    private stateStorageService: StateStorageService,
    private authenticationService: AuthenticationService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authenticationService.isLoggedIn().pipe(switchMap(isLoggedIn => {
      if (!isLoggedIn) {
        return this.authenticationService.redirectToLoginPage().pipe(map(() => false));
      }
      const authorities = route.data['authorities'];
      return this.checkLogin(authorities, state.url);
    }));
  }

  checkLogin(authorities: string[], url: string): Observable<boolean> {
    return this.accountService.identity().pipe(
      map(account => {
        if (!authorities || authorities.length === 0) {
          return true;
        }

        if (!account) {
          this.stateStorageService.storeUrl(url);
          return false;
        }
        if (account.supplierRoles.length === 0) {
          return false;
        }
        const hasAnyAuthority = this.accountService.hasAnyAuthority(authorities);
        if (hasAnyAuthority) {
          return true;
        }
        if (isDevMode()) {
          console.error('User has not any of required authorities: ', authorities);
        }
        this.router.navigate(['accessdenied']);
        return false;
      })
    );
  }
}
